module.exports = __webpack_public_path__ + "static/esco-6-bbc4cd891df8e89985a8a952997fc035.png";